import announcementRoutes from './business/announcements';
import dashboardRoutes from './business/dashboard';
import departmentRoutes from './business/departments';
import dictionaryRoutes from './business/dictionaries';
import operationRoutes from './business/operations';
import { protectBusinessRoutes } from './business/permissions';
import positionRoutes from './business/positions';
import roleRoutes from './business/roles';
import securityRoutes from './business/security';
import { normalizeSecurityPermissionProblems } from './business/security-errors';
import settingsRoutes from './business/settings';
import systemRoutes from './business/system';
import userRoutes from './business/users';

export default [
  dashboardRoutes,
  userRoutes,
  roleRoutes,
  departmentRoutes,
  positionRoutes,
  dictionaryRoutes,
  announcementRoutes,
  operationRoutes,
  settingsRoutes,
  securityRoutes,
  systemRoutes,
].flatMap((routes) => {
  const protectedRoutes = normalizeSecurityPermissionProblems(
    protectBusinessRoutes(routes),
  );
  return Array.isArray(protectedRoutes) ? protectedRoutes : [protectedRoutes];
});
